import { Component, Input } from '@angular/core';
import {KngBreadcrumbsService} from "@layout/kingswell/services/kngBreadcrumbs.service";

@Component({
  selector: 'kng-header',
  templateUrl: './kng-header.component.html'
})
export class KngHeaderComponent {

  @Input()
  public title: string;

  @Input('additional-classes')
  public additionalClasses: string = '';

  @Input()
  public showBottomLine : boolean;

  constructor(private kngBreadcrumbsService: KngBreadcrumbsService) { }

  onBack() {
    this.kngBreadcrumbsService.back();
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-header/kng-header.component.ts